import { client } from '../http';

async function sendEvent(data) {
  await client.post('/api/no-auth/pocket-money', data);
}

export default {
  sendEvent,
};
